import React from 'react';

import { Box, Typography } from '@mui/material';

import { EMPTY_INBOX_CONTENT_IMG } from 'src/assets';
import type { SxProp } from 'src/types/mui';

export const InboxItemEmptyContent: React.FC = () => {
  return (
    <Box sx={emptyInboxContentStyles}>
      <img style={{ width: '260px' }} alt="Empty inbox" src={EMPTY_INBOX_CONTENT_IMG} />
      <Typography variant="h1" mt={3.5} sx={headingStyles}>
        Choose request
        <br /> and lets look closer
      </Typography>
      <Typography variant="body2" mt={2} sx={subtitleStyle}>
        Select something from the list on the left to start working with employees requests
      </Typography>
    </Box>
  );
};

const emptyInboxContentStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexFlow: 'column',
  height: '100%',
  p: 5,
};

const headingStyles: SxProp = theme => ({
  fontSize: '32px',
  fontWeight: '600',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
  },
});

const subtitleStyle: SxProp = {
  width: '420px',
  textAlign: 'center',
};
